import { Component, OnInit, Output, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { ListColumn } from 'src/app/models/list-column.model';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { OemService } from 'src/app/services/oem/oem.service';
import Swal from 'sweetalert2';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { PermissionService } from 'src/app/services/permission.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { WebinarFilterComponent } from '../webinar-filter/webinar-filter.component';
import { CustomChip, GeographicalChip } from 'src/app/models/product-model';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/services/shared-service.service';
import { DatePipe } from '@angular/common';
import { GeographicalType } from 'src/app/enums/product-enum';
import { ExportComponent } from '../../dashboard/distributor/export/export.component';
import { DISTRIBUTOR_ID, OEM_ID, ROLE_NAME, USER_ID } from 'src/app/utils/constants';
import { filter } from 'rxjs';

@Component({
  selector: 'app-webinars',
  templateUrl: './webinars.component.html',
  styleUrls: ['./webinars.component.css'],
  providers: [DatePipe]
})
export class WebinarsComponent implements OnInit {
  products: any[] = [];
  @Output() addWebinar: boolean = false;
  @Output() updateWebinar: boolean = false;
  @Output() updateWebinarID?: string;
  @Output() viewWebinar: boolean = false;
  @Output() viewWebinarID: any;
  @Output() webinarId = new EventEmitter<string>();

  oemId: any;
  dateTime: any;
  fieldsToInclude: string[] = ['webinarSequenceId', 'orgName', 'webinarTitle', 'timezone', 'registeredCustomerCount', 'speakersName'];
  fieldsToExport: string[] = ['orgName', 'aboutWebinar', 'sponsored', 'timezone', 'webinarSequenceId', 'registeredCustomerCount', 'hostImage', 'webinarTime', 'webinarDate', 'speakersName', 'speciality', 'image', 'webinarTitle', 'id'];
  permissions = [];
  hasAddPermission: boolean = true;
  hasViewPermission: boolean = true;
  hasEditPermission: boolean = true;
  hasDeletePermission: boolean = true;
  searchKeyword: string = '';
  showPagination: boolean = true;
  chips: CustomChip[] = [];
  clearAllChips: boolean = false;
  isFiltered: boolean = false;
  filterObject: any = {
    speciality: [],
    orgName: [],
    createdBy: [],
    speakersName: [],
    startDate: '',
    endDate: '',
    webinarTime: [],
    status: null,
    companyName: [],
    type: null
  };
  roleName: string = '';
  allCreatorList: any[] = [];

  constructor(
    private dialog: MatDialog,
    private sweetAlertService: SweetAlertService,
    private breadcrumbService: BreadcrumbService,
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private webinarService: WebinarService,
    private oemService: OemService,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService,
    private sharedService: SharedService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe
  ) {
    this.oemId = this.getOemId();
  }

  private getStorageKey(baseKey: string): string {
    return `${baseKey}_${this.roleName || 'Unknown'}`; 
  }

  private getOemId(): string {
    switch (this.localStorageService.getItem('roleName')) {
      case 'DISTRIBUTOR':
        return this.localStorageService.getItem('distributorId');
      case 'OEM':
        return this.localStorageService.getItem('oemId');
      default:
        return this.localStorageService.getItem('userId');
    }
     this.oemId = this.localStorageService.getItem('roleName') === 'DISTRIBUTOR'
          ? this.localStorageService.getItem(DISTRIBUTOR_ID)
          : (this.localStorageService.getItem('roleName') === 'OEM'
            ? this.localStorageService.getItem(OEM_ID)
            : this.localStorageService.getItem(USER_ID));
        this.roleName =this.localStorageService.getItem('roleName');
  }


  private resetFilterState(): void {
    const nonScopedKeys = ['webinarsFilter', 'webinarsChips', 'webinarsSearch', 'webinarsPageIndex', 'webinarsPageSize'];
    nonScopedKeys.forEach(key => sessionStorage.removeItem(key));

    this.filterObject = {
      speciality: [],
      orgName: [],
      createdBy: [],
      speakersName: [],
      startDate: '',
      endDate: '',
      webinarTime: [],
      status: null,
      companyName: [],
      type: null
    };
    this.chips = [];
    this.searchKeyword = '';
    this.pageIndex = 0;
    this.isFiltered = false;
  }

  columns: ListColumn[] = [
    { name: 'S.No', property: 'srNo', visible: true, isModelProperty: false },
    { name: 'Webinar Title', property: 'webinarTitle', visible: true, isModelProperty: true, isText: true },
    { name: 'Type', property: 'type', visible: true, isModelProperty: true, isText: true },
    { name: 'Organiser Name ', property: 'orgName', visible: true, isModelProperty: true, isText: true },
    { name: 'Date/Time', property: 'webinarTime', visible: true, isModelProperty: true, isText: true },
    { name: 'Timezone', property: 'timezone', visible: true, isModelProperty: true, isText: true },
    { name: 'Speakers', property: 'speakersName', visible: true, isModelProperty: true, isRole: true },
    { name: 'Speciality', property: 'speciality', visible: true, isModelProperty: true, isText: true },
    {name:'Other Speciality', property: 'otherSpeciality', visible: true, isModelProperty: true, isText: true },
    { name: 'Registrations', property: 'registeredCustomerCount', visible: true, isModelProperty: true, isText: true },
    { name: 'Status', property: 'status', visible: true, isModelProperty: true, isWebinarStatus: true },
    { name: 'Company Name', property: 'companyName', visible: true, isModelProperty: true, isText: true },
    { name: 'Created By', property: 'createdBy', visible: true, isModelProperty: true, isText: true },
    { name: 'Created On', property: 'createdOn', visible: true, isModelProperty: true, isText: true },
    {
      name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
      actions: [
        { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
        { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
        { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
      ]
    }
  ] as ListColumn[];

  
  ngOnInit(): void {
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Webinars']);
    if (this.localStorageService.getItem('preferences') && this.localStorageService.getItem('preferences').length > 0) {
      this.updatePermissions();
    }
    
    if (!sessionStorage.getItem('webinarsFilter') && !sessionStorage.getItem('webinarsChips')) {
      this.resetFilterState();
    }
        
    this.restorePreviousSearch();
    this.restoreFiltersFromSession();
    this.createFilterChips(this.filterObject);
    this.restorePaginationState(); 
    this.displayData();
    this.getWebinarsSummary();

  }
  restoreFiltersFromSession() {
    const savedFilters = sessionStorage.getItem('webinarsFilter');
    if (savedFilters) {
      this.filterObject = JSON.parse(savedFilters);
      this.isFiltered = this.hasActiveFilters();
    } else {
      this.filterObject = {
        speciality: [],
        orgName: [],
        createdBy: [],
        speakersName: [],
        startDate: '',
        endDate: '',
        webinarTime: [],
        status: null,
        companyName: [],
        type: null
      };
      this.isFiltered = false;
    }

  }
  

  restorePreviousSearch() {
    const search = sessionStorage.getItem('webinarsSearch');
    if (search) {
      this.searchKeyword = search;
    } else if (search === "" || search === null || search === undefined) {
      this.searchKeyword = '';
    }
    if(!this.isFiltered){
    const chipsObj = sessionStorage.getItem('webinarsChips');
    if (chipsObj) {
      this.chips = JSON.parse(chipsObj);
    }}
  }
  

  updatePermissions() {
    this.permissions = this.localStorageService.getItem('preferences');
    this.hasAddPermission = this.permissionService.hasPermission('WEBINAR_CREATE', this.permissions);
    this.hasViewPermission = this.permissionService.hasPermission('WEBINAR_VIEW', this.permissions);
    this.hasEditPermission = this.permissionService.hasPermission('WEBINAR_EDIT', this.permissions);
    this.hasDeletePermission = this.permissionService.hasPermission('WEBINAR_DELETE', this.permissions);
    
    let columns = [
      { name: 'S.No', property: 'srNo', visible: true, isModelProperty: false },
      { name: 'Webinar Title', property: 'webinarTitle', visible: true, isModelProperty: true, isText: true },
      { name: 'Type', property: 'type', visible: true, isModelProperty: true, isText: true },
      { name: 'Organiser Name ', property: 'orgName', visible: true, isModelProperty: true, isText: true },
      { name: 'Date/Time', property: 'webinarTime', visible: true, isModelProperty: true, isText: true },
      { name: 'Timezone', property: 'timezone', visible: true, isModelProperty: true, isText: true },
      { name: 'Speakers', property: 'speakersName', visible: true, isModelProperty: true, isRole: true },
      { name: 'Speciality', property: 'speciality', visible: true, isModelProperty: true, isText: true },
      { name: 'Registrations', property: 'registeredCustomerCount', visible: true, isModelProperty: true, isText: true },
      { name: 'Status', property: 'status', visible: true, isModelProperty: true, isWebinarStatus: true },
      { name: 'Company Name', property: 'companyName', visible: true, isModelProperty: true, isText: true },
      { name: 'Created By', property: 'createdBy', visible: true, isModelProperty: true, isText: true },
      { name: 'Created On', property: 'createdOn', visible: true, isModelProperty: true, isText: true },
    ];
    
    if (this.hasAddPermission && !this.hasViewPermission && !this.hasDeletePermission && !this.hasEditPermission) {
      this.columns = columns;
    } else {
      let action: any = {
        name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
        actions: []
      };
      if (this.hasViewPermission) {
        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
      }
      if (this.hasEditPermission) {
        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
      }
      if (this.hasDeletePermission) {
        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
      }
      columns.push(action);
      this.columns = columns;
    }
  }

  data: any = [];
  pageIndex: number = 0;
  pageSize: number = 10;
  isPagination: boolean = true;
  totalEntries: number = 0;

  checkDateAndTime(data: any) {
    return data.map((item: any) => {
      item.webinarTime = item.webinarTime === undefined || item.webinarTime === null || item.webinarTime === "" ? "N/A" : item.webinarTime;
      item.timeZone = item.timeZone === undefined || item.timeZone === null || item.timeZone === "" ? "N/A" : item.timeZone;
      return item;
    });
  }

  displayData() {
    const roleName = this.localStorageService.getItem('roleName');
    let createdBy: string | null = null;
    createdBy = roleName === 'DISTRIBUTOR' ? this.localStorageService.getItem('distributorId') : roleName === 'OEM' ? this.localStorageService.getItem('oemId') : null;
    
    let apiCall = this.webinarService.getWebinarWithSearchKeyword(createdBy || '', this.pageIndex, this.pageSize, this.searchKeyword, this.filterObject  );

    apiCall.subscribe(
      (data) => {
        this.data = data.data || [];
        this.showPagination = this.data.length > 0;
        if (this.showPagination) {
          this.totalEntries = data.totalCount;
          this.transformData();
        } else {
          this.totalEntries = 0;
        }
        this.cdr.detectChanges();
      },
      () => {
        this.data = [];
        this.totalEntries = 0;
        this.showPagination = false;
        this.cdr.detectChanges();
      }
    );
  }

  add() {
    this.addWebinar = true;
    this.updateWebinar = false;
    this.viewWebinar = false;
  }

  objects = [
    { id :1, name: "Total Webinars", image: "assets/images/total-webinars.svg", count: 0, code: 'totalWebinars' },
    { id: 2, name: "Total Upcoming", image: "assets/images/upcoming-webinars.svg", count: 0, code: 'totalUpcoming' },
    { id: 3, name: "Total Archived", image: "assets/images/archived-webinars.svg", count: 0, code: 'totalArchieved' },
    { id: 4, name: "Total Registrations", image: "assets/images/total-registration.svg", count: 0, code: 'totalRegistrations' },
    { id: 5, name: "Total Speakers", image: "assets/images/public-speaking.svg", count: 0, code: 'totalSpeakers' }
  ];

  searchWebinar(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const keyword = inputElement.value;
    this.searchKeyword = keyword;
    if (this.searchKeyword) {
      sessionStorage.setItem('webinarsSearch', this.searchKeyword);
    } else if (this.searchKeyword === "") {
      sessionStorage.removeItem('webinarsSearch');
    }
    this.pageIndex = 0;
    this.sharedService.setSearchState(keyword, this.pageIndex, this.pageSize);
    this.savePaginationState();
    this.displayData();
    this.getWebinarsSummary();
  }

  clearSearch(): void {
    this.searchKeyword = '';
    sessionStorage.removeItem('webinarsSearch');
    this.pageIndex = 0;
    this.sharedService.setSearchState('', this.pageIndex, this.pageSize);
    this.savePaginationState();
    this.displayData();
    this.getWebinarsSummary();
  }

  getWebinarsSummary(){
      const filterData = {...this.filterObject}; 
      const roleName = this.localStorageService.getItem('roleName');
      let createdBy: string | null = null;
      createdBy = roleName === 'DISTRIBUTOR' ? this.localStorageService.getItem('distributorId') : roleName === 'OEM' ? this.localStorageService.getItem('oemId') : '';
      this.webinarService.getWebinarSummary( createdBy,this.searchKeyword,filterData).subscribe((res: any) => {
        const summaryData = res.data;
        const summaryMapping: { [key: string]: number } = {
          "Total Webinars": summaryData?.totalWebinars,
          "Total Upcoming": summaryData.totalUpcoming,
          "Total Archived": summaryData.totalArchieved,
          "Total Registrations": summaryData.totalRegistrations,
          "Total Speakers": summaryData.totalSpeakers
        };
        this.objects.forEach(obj => {
          if (summaryMapping.hasOwnProperty(obj.name)) {
            obj.count = summaryMapping[obj.name];
          } else {
            obj.count = 0;
          }
        });
      });
  }

  onSearch(event: any) {
    this.searchKeyword = event;
    if (this.searchKeyword !== "") {
      sessionStorage.setItem("webinarsSearch", this.searchKeyword);
    } else if (this.searchKeyword === "") {
      sessionStorage.removeItem("webinarsSearch");
    }
    this.pageIndex = 0;
    this.showPagination = true;
    this.savePaginationState();
    this.displayData();
  }

  onPageChanged(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.savePaginationState();
    this.displayData();
  }
showOtherSpeciality : boolean = false;
  

  deleteAction(row: any) {
    Swal.fire({
      position: 'center',
      title: 'Are you sure?',
      text: 'You will not be able to recover the deleted record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete It',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.webinarService.deleteWebinar(row.id).subscribe(
          () => {
            Swal.fire(
              'Removed!',
              'Item Removed Successfully.',
              'success'
            );
            this.displayData();
          },
          (error) => {
            Swal.fire(
              'Error',
              'There was an error deleting the item.',
              'error'
            );
          }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Item is safe.',
          'error'
        );
      }
    });
  }

  transformData() {
    if (this.data) {
      const currentDateTime = new Date();
      this.data.map((d: any) => {
        const date = d.webinarDate || '';
        const time = d.webinarTime || '';
        if (!date && !time) {
          d.webinarTime = 'N/A';
        } else if (date && !time) {
          d.webinarTime = `${date} N/A`;
        } else {
          d.webinarTime = `${date} ${time}`;
        }
        d.timezone = d.timezone ? d.timezone : 'N/A';
        if (date) {
          const formattedTime = time || '23:59:59';
          const webinarDateTime = new Date(`${date} ${formattedTime}`);
          d.status = webinarDateTime >= currentDateTime ? 'Upcoming' : 'Archived';
        } else {
          d.status = 'Upcoming';
        }
        if (typeof d.otherSpeciality === 'undefined') {
          d.otherSpeciality = 'N/A';
        }
      
        return d;
      });
    }
  }

  close(event: any) {
    this.addWebinar = false;
    this.updateWebinar = false;
    this.viewWebinar = false;
    this.displayData();
  }

  exportOEMData() {
    const dialogRef = this.dialog.open(ExportComponent, {
      height: 'auto',
      width: 'auto',
      data: {
      title: 'Webinars',
      webinarId: this.oemId ? this.oemId : ''
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Success') {
        this.sweetAlertService.showSuccess(result, "File downloaded Sucessfully!!");
      }
    });
  }

  closeToBack(event:any){
    this.addWebinar = false;
    this.displayData();
  }

  openFilter() {
    const dialogRef = this.dialog?.open(WebinarFilterComponent, {
      width: '772px',
      data: {
        filterData: JSON.parse(JSON.stringify(this.filterObject)), 
        chips: JSON.parse(JSON.stringify(this.chips)) 
      },
      disableClose: true,
      autoFocus: false,
    });
  
    dialogRef?.componentInstance.clearFilterData.subscribe(() => {
      this.chips = [];
      this.filterObject = {
        speciality: [],
        orgName: [],
        createdBy: [],
        speakersName: [],
        startDate: '',
        endDate: '',
        webinarTime: [],
        status: null,
        companyName: [],
        type: null
      };
      sessionStorage.removeItem('webinarsFilter');
      sessionStorage.removeItem('webinarsChips');
      this.isFiltered = false;
      this.pageIndex = 0;
      this.savePaginationState();
      this.displayData();
      this.getWebinarsSummary();
    });
  
    dialogRef?.afterClosed().subscribe((result: any) => {
      if (result) {  
        if (result.filterPayload) {
          this.filterObject = {
            speciality: [],
            orgName: result.filterPayload.orgName || [],
            createdBy: result.filterPayload.createdBy || [],
            speakersName: result.filterPayload.speakersName || [],
            startDate: result.filterPayload.startDate || '',
            endDate: result.filterPayload.endDate || '',
            webinarTime: [],
            status: result.filterPayload.status !== undefined ? result.filterPayload.status : null,
            companyName: result.filterPayload.companyName || [],
            type: result.filterPayload.type !== undefined ? result.filterPayload.type : null,
          };
          sessionStorage.setItem('webinarsFilter', JSON.stringify(this.filterObject));
        }
  
        if (result.chips && result.chips.length > 0) {
          this.chips = result.chips.map((chip: CustomChip) => ({
            ...chip,
            isGeographical: false
          }));
          sessionStorage.setItem('webinarsChips', JSON.stringify(this.chips));
        } else {
          this.createFilterChips(this.filterObject);
        }
  
        this.isFiltered = this.hasActiveFilters();
        this.pageIndex = 0;
        this.savePaginationState();
        this.cdr.detectChanges();
        this.displayData();
        this.getWebinarsSummary();
      }
    });
  }

  createFilterChips(filterData: any): void {
    this.chips = [];
  
    if (filterData.startDate && filterData.endDate) {
      const startDate = new Date(filterData.startDate);
      const endDate = new Date(filterData.endDate);
      if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
        const startFormatted = this.datePipe.transform(startDate, 'MM/dd/yyyy');
        const endFormatted = this.datePipe.transform(endDate, 'MM/dd/yyyy');
        this.chips.push({
          id: this.generateId(),
          name: ` ${startFormatted} - ${endFormatted}`,
          isGeographical: false,
          type: GeographicalType.DATE,
          priority: 1
        });
      }
    }
  
    if (filterData.speakersName && Array.isArray(filterData.speakersName)) {
      filterData.speakersName.forEach((speaker: string) => {
        if (speaker && !this.chips.some(chip => chip.name === speaker && chip.type === GeographicalType.SPEAKER)) {
          this.chips.push({
            id: this.generateId(),
            name: speaker,
            isGeographical: false,
            type: GeographicalType.SPEAKER,
            priority: 2
          });
        }
      });
    }
  
    if (filterData.orgName && Array.isArray(filterData.orgName)) {
      filterData.orgName.forEach((org: string) => {
        if (org && !this.chips.some(chip => chip.name === org && chip.type === GeographicalType.ORGANIZATION)) {
          this.chips.push({
            id: this.generateId(),
            name: org,
            isGeographical: false,
            type: GeographicalType.ORGANIZATION,
            priority: 3
          });
        }
      });
    }
     if (filterData.companyName && Array.isArray(filterData.companyName)) {
      filterData.companyName.forEach((company: string) => {
        if (company && !this.chips.some(chip => chip.name === company && chip.type === GeographicalType.COMPANY_NAME)) {
          this.chips.push({
            id: this.generateId(),
            name: company,
            isGeographical: false,
            type: GeographicalType.COMPANY_NAME,
            priority: 4
          });
        }
      });
    }
    
    if (filterData.createdBy && Array.isArray(filterData.createdBy)) {
      filterData.createdBy.forEach((creatorId: string) => {
        const creator = this.allCreatorList?.find((c: any) => c.id === creatorId);
        const creatorName = creator?.name || creatorId;
        
        if (creatorName && !this.chips.some(chip => chip.name === creatorName && chip.type === GeographicalType.CREATED_BY)) {
          this.chips.push({
            id: this.generateId(),
            name: creatorName,
            isGeographical: false,
            type: GeographicalType.CREATED_BY,
            priority: 5
          });
        }
      });
    }
  
    if (filterData.status !== null && filterData.status !== undefined) {
      const statusLabel = typeof filterData.status === 'string' 
        ? (filterData.status === 'archived' ? 'Archived' : 'Upcoming')
        : (filterData.status ? 'Upcoming' : 'Archived');
      this.chips.push({
        id: this.generateId(),
        name: statusLabel,
        isGeographical: false,
        type: GeographicalType.STATUS,
        priority: 6
      });
    }

    if (filterData.type !== null && filterData.type !== undefined) {
      const typeLabel = typeof filterData.type === 'string' ? (filterData.type === "cme" ? "CME" : "Webinar"):(filterData.type ? "Webinar" : "CME");
      this.chips.push({
        id: this.generateId(),
        name: typeLabel,
        isGeographical: false,
        type: GeographicalType.TYPE,
        priority: 7
      });
    }
  
    this.chips.sort((a, b) => a.priority - b.priority);
    sessionStorage.setItem('webinarsChips', JSON.stringify(this.chips));
  }
  
  generateId(): number {
    return Math.floor(Math.random() * 100000);
  }

  remove(removedChip: CustomChip) {
    this.chips = this.chips.filter((chip: CustomChip) => chip !== removedChip);
  
    switch (removedChip.type) {
      case GeographicalType.SPEAKER:
        this.filterObject.speakersName = this.filterObject.speakersName.filter((speaker: string) => speaker !== removedChip.name);
        break;
      case GeographicalType.ORGANIZATION:
        this.filterObject.orgName = this.filterObject.orgName.filter((org: string) => org !== removedChip.name);
        break;
      case GeographicalType.STATUS:
        this.filterObject.status = null;
        break;
      case GeographicalType.TYPE:
        this.filterObject.type = null;
        break;
      case GeographicalType.DATE:
        this.filterObject.startDate = '';
        this.filterObject.endDate = '';
        break;
        case GeographicalType.CREATED_BY:
          const creatorsToRemove = this.allCreatorList
            .filter((creator: any) => creator.name === removedChip.name)
            .map((creator: any) => creator.id);
            
          if (creatorsToRemove.length > 0) {
            this.filterObject.createdBy = this.filterObject.createdBy.filter(
              (id: string) => !creatorsToRemove.includes(id)
            );
          } else {
            this.filterObject.createdBy = [];
          }
      break;
      case GeographicalType.COMPANY_NAME:
        this.filterObject.companyName = this.filterObject.companyName.filter((org: string) => org !== removedChip.name);
        break;
      default:
        break;  
    }
    sessionStorage.setItem('webinarsChips', JSON.stringify(this.chips));
    sessionStorage.setItem('webinarsFilter', JSON.stringify(this.filterObject));
    this.isFiltered = this.hasActiveFilters();
    this.pageIndex = 0;
    this.savePaginationState();
    this.displayData();
    this.getWebinarsSummary();
  }

  clearAllFilters(): void {
    this.clearAllChips = true;
    this.chips = [];
    this.filterObject = {
      speciality: [],
      orgName: [],
      createdBy: [],
      speakersName: [],
      startDate: '',
      endDate: '',
      webinarTime: [],
      status: null,
      companyName: [],
      type: null
    };
    this.isFiltered = false;
    sessionStorage.removeItem('webinarsFilter');
    sessionStorage.removeItem('webinarsChips');
    this.pageIndex = 0;
    this.savePaginationState();
    this.displayData();
    this.getWebinarsSummary();
  }

  hasActiveFilters(): boolean {
    return !!(this.filterObject.speakersName?.length > 0 ||
      this.filterObject.orgName?.length > 0 ||
      this.filterObject.companyName?.length > 0 ||
      this.filterObject.createdBy?.length > 0 ||
      (this.filterObject.startDate && this.filterObject.startDate !== '') ||
      (this.filterObject.endDate && this.filterObject.endDate !== '') ||
      this.filterObject.status !== null ||
      this.filterObject.type !== null);
  }

  removeFilter(filterKey: string): void {
    const scalarFilters = ['status']; 
    if (this.filterObject.hasOwnProperty(filterKey)) {
      this.filterObject[filterKey] = scalarFilters.includes(filterKey) ? null : [];
    }
  
    this.createFilterChips(this.filterObject);
    this.isFiltered = this.hasActiveFilters();
  
    sessionStorage.setItem('webinarsFilter', JSON.stringify(this.filterObject));
    sessionStorage.setItem('webinarsChips', JSON.stringify(this.chips ?? []));
  
    this.pageIndex = 0;
    this.savePaginationState();
    this.displayData();
  }
  

  selectedAction(event: any) {
    this.savePaginationState();
    switch (event.action) {
      case MweConstants.addAction:
        this.updateWebinar = false;
        this.addWebinar = true;
        this.router.navigate(['./add'], { relativeTo: this.activatedRoute });
        break;
      case MweConstants.editAction:
        this.updateWebinar = true;
        this.updateWebinarID = event.row.id;
        this.router.navigate(['./edit', this.updateWebinarID], { relativeTo: this.activatedRoute });
        break;
      case MweConstants.deleteAction:
        this.deleteAction(event.row);
        break;
      case MweConstants.viewAction:
        this.viewWebinar = true;
        this.viewWebinarID = event.row.id;
        this.router.navigate(['./view', this.viewWebinarID], { relativeTo: this.activatedRoute });
        break;
      case MweConstants.filterAction:
        this.openFilter();
        break;
      default:
        break;
    }
  }
  private restorePaginationState(): void {
    const savedPageIndex = sessionStorage.getItem(this.getStorageKey('webinarsPageIndex'));
    const savedPageSize = sessionStorage.getItem(this.getStorageKey('webinarsPageSize'));
    if (savedPageIndex !== null) {
      this.pageIndex = parseInt(savedPageIndex, 10);
    }
    if (savedPageSize !== null) {
      this.pageSize = parseInt(savedPageSize, 10);
    }
  }
  savePaginationState() {
    sessionStorage.setItem(this.getStorageKey('webinarsPageIndex'), this.pageIndex.toString());
    sessionStorage.setItem(this.getStorageKey('webinarsPageSize'), this.pageSize.toString());
  }
}
